import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "foreigner";

moduleApi.list = dataFilter => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "Upload Selfie photo successfully", //string | null | comment
      error: "Upload Selfie photo failed",  //string | null | comment
    }
  };
  return ApiService(api);
};

moduleApi.updateRemoveSelfiePhoto = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "Remove Selfie photo successfully", //string | null | comment
      error: "Remove Selfie photo failed",  //string | null | comment
    }
  };
  return ApiService(api);
};

moduleApi.registerForeigner = (data) => {
  let api = {
    module: moduleName,
    type: "registerForeigner",
    value: data,
    params: {
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.check_required_change_password = (data) => {
  let api = {
    module: moduleName,
    type: "check_required_change_password",
    value: data,
    params: {
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.clear_required_change_password = (data) => {
  let api = {
    module: moduleName,
    type: "clear_required_change_password",
    value: data,
    params: {
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.sendEmail = (data) => {
  let api = {
    module: moduleName,
    type: "sendEmail",
    value: data,
    params: {
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.ocr = (id) => {
  let api = {
    module: moduleName,
    type: "ocr",
    value: {},
    params: {
      id
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};

moduleApi.verifyFace = (passport_img_id, selfie_img_id) => {
  let api = {
    module: moduleName,
    type: "verifyFace",
    value: {},
    params: {
      passport_img_id,
      selfie_img_id
    },
    message: {
      success: "hidden", //string | null | comment
      error: "hidden",  //string | null | comment
    }

  };
  return ApiService(api);
};


export default moduleApi;
